// just helper logging function
function l($obj){
    console.log($obj);
}